import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Select } from "antd";
import { getTotesFenofases, getIdEspecie, getIdFenofase } from "../../reducers";
import styles from "./VisualitzacioSelectorFenofase.module.css";
import { omplirIdFenofaseVisualitzacio } from "../../actions";
const SEPARADOR = "#%";

class VisualitzacioSelectorFenofase extends Component {
  handleOnChange = opcioSeleccionada => {
    const idFenofase = opcioSeleccionada.substr(
      opcioSeleccionada.indexOf(SEPARADOR) + SEPARADOR.length
    );
    const constIdFenofaseInt = isNaN(parseInt(idFenofase))
      ? 0
      : parseInt(idFenofase);

    const { omplirIdFenofaseVisualitzacio } = this.props;
    omplirIdFenofaseVisualitzacio(constIdFenofaseInt);
  };

  getTotesFenofases = (fenofases, idEspecie) => {
    return Array.isArray(fenofases) && idEspecie ? fenofases : [];
  };

  getListaFenofasesIdEspecie = (fenofases, idEspecie) => {
    if (!fenofases || !idEspecie) {
      return [];
    }
    return fenofases.filter(fenofase => {
      return fenofase.idEspecie === idEspecie;
    });
  };

  getFenofaseSeleccionada = (listaFenofases, idFenofase) => {
    if (idFenofase && Array.isArray(listaFenofases)) {
      return listaFenofases.filter(fenofase => {
        return fenofase.id === idFenofase;
      });
    } else {
      return undefined;
    }
  };

  render() {
    const { Option } = Select;
    const { fenofases, idEspecie, idFenofase } = this.props;
    const totesFenofases = this.getTotesFenofases(fenofases, idEspecie);
    const listaFenofasesIdEspecie = this.getListaFenofasesIdEspecie(
      totesFenofases,
      idEspecie
    );

    const llistaFenofaseSeleccionada =
      fenofases && fenofases.length
        ? fenofases.filter(fenofase => {
            return fenofase.id === idFenofase;
          })
        : [];

    const nomFenofaseSeleccionada =
      llistaFenofaseSeleccionada && llistaFenofaseSeleccionada.length > 0
        ? llistaFenofaseSeleccionada[0].nom
        : "";

    const valor =
      nomFenofaseSeleccionada && idFenofase
        ? nomFenofaseSeleccionada + SEPARADOR + idFenofase
        : idEspecie && listaFenofasesIdEspecie.length === 1
          ? listaFenofasesIdEspecie[0].nom +
            SEPARADOR +
            listaFenofasesIdEspecie[0].id
          : "Seleccionar la fenofase...";

    return (
      <div className={styles.visualitzacioSelector}>
        <label htmlFor="id-fenofase">Seleccionar la fenofase</label>

        <Select
          showSearch
          style={{ width: "100%", maxHeight: 100 }}
          id="id-fenofase"
          onChange={this.handleOnChange}
          value={valor}
        >
          {listaFenofasesIdEspecie.map(fenofase => {
            return (
              <Option
                key={fenofase.id}
                value={fenofase.nom + SEPARADOR + fenofase.id}
              >
                {fenofase.nom}
              </Option>
            );
          })}
        </Select>
      </div>
    );
  }
}

VisualitzacioSelectorFenofase.propTypes = {
  omplirIdFenofaseVisualitzacio: PropTypes.func.isRequired,
  fenofases: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      nom: PropTypes.string.isRequired,
      idEspecie: PropTypes.number.isRequired
    })
  ),
  idEspecie: PropTypes.number,
  idFenofase: PropTypes.number
};

const mapStateToProps = state => {
  return {
    fenofases: getTotesFenofases(state),
    idEspecie: getIdEspecie(state),
    idFenofase: getIdFenofase(state)
  };
};

export default connect(mapStateToProps, { omplirIdFenofaseVisualitzacio })(
  VisualitzacioSelectorFenofase
);
